
// EditStudent Component for update student data 

// Import Modules 
import React, { useState, useEffect } from "react";
import { useParams, useNavigate,useOutletContext } from "react-router-dom";
import axios from "axios";
import { useLocation } from "react-router-dom";
import PatientCIForm from "../Forms/PatientCIForm";
import CONFIG from '../../config';
import { usePatient } from "../../context/PatientContext";
import { useAuth } from "../../context/AuthProvider";


// EditStudent Component 
const EditPatientCI = () => {
  const location = useLocation();
  const { patientData, setPatientData, selectedCase, selectedVisit, doctorInfo } = usePatient();
  const {patientId, caseId, visitId} = useParams();
  //    const { patientId, caseId, visitId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { markSectionComplete } = useOutletContext() ;  
  const { verifyTokenAndRedirect } = useAuth();


  useEffect(() => {

    verifyTokenAndRedirect();

  }, []);


  //onSubmit handler 
  const onSubmitHandler = (updatedPatientCI) => {

    //alert("On Submit");

    console.log("patient data after submit:", updatedPatientCI); // Log the data to be updated
    console.log("global patient data on submit of CI before merging:", patientData );

    // const updatedData = {
    //   ...patientData,
    //   patientClinicalInvestigation: [{ ...updatedPatientCI }] // Overwrite patientInfo while keeping other data unchanged
    // };
    
    // const updatedData = {
    //   ...patientData, 
    //   patientClinicalInvestigation: patientData.patientClinicalInvestigation.map(info => ({
    //       ...info, // Keep existing patientInfo fields
    //       ...updatedPatientCI // Merge updated fields
    //   }))
    // };

  //   const updatedData = {
  //     ...patientData,
  //     patientClinicalInvestigation: patientData.patientClinicalInvestigation.length > 0 
  //         ? patientData.patientClinicalInvestigation.map(info => ({
  //             ...info, // Keep existing patientInfo fields
  //             ...updatedPatientCI // Merge updated fields
  //         }))
  //         : [updatedPatientCI] // If empty, create a new array with updatedPatientCI
  // };


//   const updatedData = {
//     ...patientData,
//     patientClinicalInvestigation: patientData.patientClinicalInvestigation.length > 0 
//         ? patientData.patientClinicalInvestigation.map(info => ({
//             ...info, // Keep existing patientInfo fields
//             ...updatedPatientCI // Merge updated fields
//         }))
//         : [updatedPatientCI] // If empty, create a new array with updatedPatientCI
// };

const updatedData = {
  ...patientData,
  patientClinicalInvestigation: patientData?.patientClinicalInvestigation?.length > 0 
      ? patientData.patientClinicalInvestigation.map(info => ({
          ...info, // Keep existing patientInfo fields
          ...updatedPatientCI, // Merge updated fields
          PATIENT_ID: patientData.PATIENT_ID, 
          CASE_ID: selectedCase || caseId, // Add CASE_ID if missing
          VISIT_ID: selectedVisit || visitId,  // Add VISIT_ID if missing
          DOCTOR_ID: doctorInfo.MANDALI_ID,
          CLINIC_ID: doctorInfo.CLINIC_ID // Merge updated fields
  
      }))
      : [{
          ...updatedPatientCI,
          PATIENT_ID: patientData.PATIENT_ID, 
          CASE_ID: selectedCase || caseId,  // Default CASE_ID if not provided
         VISIT_ID: selectedVisit || visitId, // Default VISIT_ID if not provided
         DOCTOR_ID: doctorInfo.MANDALI_ID,
         CLINIC_ID: doctorInfo.CLINIC_ID // Merge updated fields
 
      }]
};



    setPatientData(updatedData);
    markSectionComplete("ci");
    if (location.pathname.startsWith("/addpatient")) {
      navigate("/addpatient/anyavyadhi");
    } else if (location.pathname.startsWith("/visits")) {
      navigate(`/visits/${patientId}/${caseId}/${visitId}/anyavyadhi`);
    } else {
      console.warn("Unknown route, no redirection");
    }
  };

  // Return student form 
  return (

    <div>
      {console.log('inside rendering: ', patientData)}
      {patientData || (patientId === undefined && caseId === undefined && visitId === undefined) ? (
        <PatientCIForm
          initialValues={patientData}
          onSubmit={onSubmitHandler}
          enableReinitialize={true}
        >
          Update Patient
        </PatientCIForm>
      ):(
        <p>Loading....</p>
      )}
    </div>
  );

};

export default EditPatientCI;

